import { tableStyle, cellStyle } from 'appConstants';
import { buildRootPageWrapperHtml } from 'helpers';

export default function (editor, opt = {}) {
  const bm = editor.BlockManager;

  bm.add('column48', {
    label: opt.labelColumn48,
    category: opt.category,
    content: `
      <table data-type="section" style="${tableStyle}">
        <tr>
          <td style="${cellStyle} width: 33%"></td>
          <td style="${cellStyle} width: 66%"></td>
        </tr>
      </table>
    `,
  });

  bm.add('column84', {
    label: opt.labelColumn84,
    category: opt.category,
    content: `
      <table data-type="section" style="${tableStyle}">
        <tr>
          <td style="${cellStyle} width: 66%"></td>
          <td style="${cellStyle} width: 33%"></td>
        </tr>
      </table>
    `,
  });

  bm.add('column39', {
    label: opt.labelColumn39,
    category: opt.category,
    content: `
      <table data-type="section" style="${tableStyle}">
        <tr>
          <td style="${cellStyle} width: 25%"></td>
          <td style="${cellStyle} width: 75%"></td>
        </tr>
      </table>
    `,
  });

  bm.add('column93', {
    label: opt.labelColumn93,
    category: opt.category,
    content: `
      <table data-type="section" style="${tableStyle}">
        <tr>
          <td style="${cellStyle} width: 75%"></td>
          <td style="${cellStyle} width: 25%"></td>
        </tr>
      </table>
    `,
  });

  bm.add('column3-7', {
    label: opt.labelColumn37,
    category: opt.category,
    content: `
    <table data-type="section" style="${tableStyle}">
      <tr>
        <td style="${cellStyle} width:30%"></td>
        <td style="${cellStyle} width:70%"></td>
      </tr>
      </table>
    `,
  });

  bm.add('column4', {
    label: opt.labelColumn4,
    category: opt.category,
    content: `
      <table data-type="section" style="${tableStyle}">
        <tr>
          <td style="${cellStyle} width: 25%"></td>
          <td style="${cellStyle} width: 25%"></td>
          <td style="${cellStyle} width: 25%"></td>
          <td style="${cellStyle} width: 25%"></td>
        </tr>
      </table>
    `,
  });

  bm.add('root', {
    label: 'Page Wrapper',
    attributes: { class: 'bpreview-page-wrapper' },
    category: opt.category,
    content: buildRootPageWrapperHtml({ widthPx: 700 }),
  });
}
